import styled from 'styled-components';
import { animated } from 'react-spring';
import { boxShadow } from 'js/config/style';

export default animated(styled.div`
  width: 100%;
  background: white;
  box-shadow: ${boxShadow};
`);
